import { useEffect } from 'react';

import { AppointmentAnalyticService } from 'features/order-tracker/store/sagas/services/appointmentAnalyticsService';

export const useTrackModalLoadAnalytics = (ref: React.RefObject<HTMLDivElement | null>, value: string): void => {
  useEffect(() => {
    !!ref && AppointmentAnalyticService.trackAppointmentEvent({ ref, value });
  }, []);
};
